import { ComponentType, ReactNode } from 'react'
// Styled
import { styled } from '@mui/material/styles'
// Components
import {
  Typography,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import { nothing } from '$func/utils'

const ACTION_BUTTON_HEIGHT = 50
const ACTION_BUTTON_MARGIN_BOTTOM = 10

export const ACTION_BUTTON_CONSUMED_HEIGHT =
  ACTION_BUTTON_HEIGHT + ACTION_BUTTON_MARGIN_BOTTOM

const StyledListItem = styled(ListItem)`
  margin-bottom: 10px;
  background-color: white;

  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.05);
`

const StyledListItemButton = styled(ListItemButton)`
  min-height: 50px;

  box-sizing: border-box;
  padding: 0 20px 0 20px;
`

const StyledListItemIcon = styled(ListItemIcon)`
  min-width: unset;
  margin-left: 10px;
`

interface Props {
  text: string
  icon: ReactNode
  onClick: () => any
}

export function ActionButton({ text, icon, onClick = nothing }: Props) {
  return (
    <StyledListItem disablePadding sx={{ mb: '10px' }}>
      <StyledListItemButton onClick={onClick}>
        <StyledListItemIcon>{icon}</StyledListItemIcon>
        <ListItemText
          primary={
            <Typography variant="body2" color="secondary">
              {text}
            </Typography>
          }
        />
      </StyledListItemButton>
    </StyledListItem>
  )
}
